@use "../../../scss/settings/breakpoints";

.checkbox_container {
  margin-top: 16px;
}

.modal_container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.title_container {

  svg {
    width: 30px;
    height: 30px;
  }

}

.textarea_container {
  width: 100%;

  label {
    transform: translate(14px, -9px) scale(0.75) !important;
  }

}

.w100 {
  width: 100%
}


// ---------- Responsive ----------
.modal_container {
  box-sizing: border-box;
  padding: 16px;
  overflow-y: auto;
}
